module.exports = __webpack_public_path__ + "img/10.42b1867d.jpg";